/* eslint-disable unicorn/consistent-function-scoping */
import Áxios, { AxiosRequestConfig } from 'axios';
import { AppState, AppThunkDispatch } from '../..';
import { CompleteUpload, RegisterArguments } from '../../../services/types';
import { CSVToArray, createChunks, parametersAsObject, stringToBlob } from '../../../globals/utils';
import FileStorage from '../../../services/file-storage';
import { enqueueSnackbarAction } from '../../snackbar/actions';
import MessageParser from '../../../services/message-parser';

export const messageReplayService =
    ({
        file,
        setPercentUpload,
        queryParameters
    }: {
        file: File;
        setPercentUpload: Function;
        queryParameters: any;
    }) =>
        async (dispatch: AppThunkDispatch, getState: () => AppState) => {
            const {
                login: { client, envVariables },
            } = getState();

            const filetext = await file.text();
            const fileBlob = stringToBlob(filetext, 'text/csv');
            if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
                dispatch(
                    enqueueSnackbarAction({
                        message: 'Must be a csv file',
                        options: { variant: 'error' },
                    }),
                );
                return null;
            }
            const delimiter = '\r\n';
            const rawRows = CSVToArray(filetext, delimiter);
            const csvMessageReplayString = 'Record Id,Device Key';
            const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
            if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === csvMessageReplayString)
            )) {
                dispatch(
                    enqueueSnackbarAction({
                        message: `The CSV file must be valid`,
                        options: { variant: 'error' },
                    }),
                );
                return null;
            }
            rowsWithheader.shift();
            const rows = rowsWithheader;
            if (rows.length === 0) {
                dispatch(
                    enqueueSnackbarAction({
                        message: `The CSV file must have minimum 1 row`,
                        options: { variant: 'error' },
                    }),
                );
                return null;
            }

            const clientAuth: any = client?.authenticate();
            const userId = clientAuth.loginId;
            const { storageV1BaseUrl, parsedMessageV1BaseUrl } = envVariables;
            const storage = new FileStorage(client, storageV1BaseUrl);
            const messageParserService = new MessageParser(client, parsedMessageV1BaseUrl);
            const chunks = createChunks(file, 10);
            const numberOfParts = chunks.length;
            const partyNumber = 'CAT';
            const registrationInputs: RegisterArguments = {
                queryParameters: {
                    numberOfParts,
                    partyNumber,
                    fileName: file?.name,
                    origin: 'iot-gateway',
                    ttl: 86400,
                    contentType: 'application/bin',
                },
            };
            try {
                let percentUpload = 10;
                setPercentUpload(percentUpload);
                const {
                    data: { uploadUrls, id, uploadId },
                } = await storage.multiPartRegister(registrationInputs);
                const uploadMultiple = () =>
                    uploadUrls.map(async (uploadUrl, iterator) => {
                        const uploadPercentage = 50 / uploadUrls.length;
                        const url = uploadUrl.split('?');
                        const parameterString: URLSearchParams | any = new URLSearchParams(url[1]);
                        const urlParameters = parametersAsObject(parameterString);
                        const request: AxiosRequestConfig = {
                            url: url[0],
                            params: urlParameters,
                            method: 'PUT',
                            data: chunks[iterator],
                            headers: {
                                'Content-Type': 'application/octet-stream',
                            },
                        };
                        const uploadResponse = await Áxios(request);
                        percentUpload += uploadPercentage;
                        setPercentUpload(percentUpload);
                        return uploadResponse;
                    });

                await Promise.all(uploadMultiple());

                const completionInput: CompleteUpload = {
                    queryParameters: {
                        uploadId,
                        id,
                    },
                };
                const {
                    data,
                } = await storage.multiPartCompleteUpload(completionInput);
                percentUpload += 10;
                setPercentUpload(percentUpload);
                const { replayType, requestedBy, changeTicketNumber } = queryParameters;
                const requestedByParameters = requestedBy && requestedBy.toString();
                const requestQueryParameters = { id, replayType, requestedBy: requestedByParameters, changeTicketNumber };

                await messageParserService.postReplayMessage(requestQueryParameters);
                dispatch(
                    enqueueSnackbarAction({
                        message: 'Message Replay Request Accepted',
                        options: {
                            variant: 'success',
                        },
                    }),
                );
                return null;
            }
            catch (error: any) {
                dispatch(
                    enqueueSnackbarAction({
                        message: 'Error while Uploading Message Replay',
                        options: {
                            variant: 'error',
                        },
                    }),
                );
                return null;
            }
        };

